import {GlobalState} from "../../global/GlobalState";
import {renderText} from "../../components/common/TextRenderer";
import {translateFunction} from "../../localization/TranslationService";

const translate = translateFunction();

/**
 * Soft verifies the user's authorization based on the JWT information.
 * Real authorization needs to happen on the backend.
 *
 * @param groupNames the names of the groups, case sensitive
 * @return true if the currently logged on user is a member of at least one of the groups
 */
export function isAuthorizedByAnyGroup(groupNames: string[]): boolean {
	return groupNames.some(isAuthorizedByGroup);
}

/**
 * Soft verifies the user's authorization based on the JWT information.
 * Real authorization needs to happen on the backend.
 *
 * @param groupName the name of the group, case sensitive
 * @return true if the currently logged on user is a member of the group
 */
export function isAuthorizedByGroup(groupName: string): boolean {
	const userSession = GlobalState.userSession;
	return !!userSession && userSession.user.groups.indexOf(groupName) >= 0;
}

export function isAuthorizedByAnyPermission(permissions: string[]): boolean {
	return permissions.some(isAuthorizedByPermission);
}

export function isAuthorizedByPermission(permission: string): boolean {
	const userSession = GlobalState.userSession;
	return !!userSession && userSession.hasPermissionFor(permission);
}

export function pageAuthorizedByGroup(page: () => JSX.Element, groupNames: string[]): () => JSX.Element {
	return () => {
		if (!isAuthorizedByAnyGroup(groupNames))
			return unauthorizedPage();
		return page();
	};
}

export function pageAuthorizedByPermission(page: () => JSX.Element, permissions: string[]): () => JSX.Element {
	return () => {
		if (!isAuthorizedByAnyPermission(permissions))
			return unauthorizedPage();
		return page();
	};
}

export function unauthorizedPage() {
	let message: string;
	if (GlobalState.userSession)
		message = translate("You do not have enough permissions to view this page.\nIf your permissions recently changed, try loggin in again to update your permissions.");
	else
		message = translate("You have to be logged on to view this page, please log in and try again.");
	
	return <div>
		<h1>{translate("Not Authorized")}</h1>
		{renderText(message)}
	</div>;
}
